import { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`}>
      {message}
      <style jsx>{`
        .toast {
          position: fixed;
          bottom: 1.5rem;
          right: 1.5rem;
          padding: 0.9rem 1.4rem;
          border-radius: 8px;
          font-size: 0.95rem;
          font-weight: 500;
          z-index: 9999;
          animation: slideIn 0.2s ease, fadeOut 0.4s ease 2.6s forwards;
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
          max-width: 320px;
        }
        .toast-success { background: #22c55e; color: white; }
        .toast-error   { background: #ef4444; color: white; }
        .toast-info    { background: var(--accent-color); color: white; }
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(12px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeOut {
          to { opacity: 0; transform: translateY(12px); }
        }
      `}</style>
    </div>
  );
}
